
<div class="content-wrap">
    <div id="content" class="content admin_tool_content">		
		<div class="admin_recompute_body">
			<h3 class="recomputeWrapper">Recompute Score<span class="fw-semi-bold"></span></h3>
            <section class="widget overflow-auto pt30 widget_content">
                <form class="form-horizontal" role="form">
                    <fieldset>
                        <div class="form-group">
                            <label for="normal-field" class="col-sm-3 control-label">LEED ID</label>
                            <div class="col-sm-7" [ngClass]="loaderCert ? 'not-active' : ''">
                                <input (input)="checkInputsCert()" (focus)="checkInputsCert()" [(ngModel)]="leed_id" name="leed_id" type="text" id="normal-field" class="form-control" placeholder="LEED ID">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label" for="prepended-input">Recompute Date</label>
                            <div class="col-sm-7">                                
                                <input (input)="checkInputsCert()" [ngInit]="enableFdatePicker()" type="text" [(ngModel)]="end_date" id="end_date" name="end_date" class="col-sm-7 form-control"  [ngClass]="loaderCert ? 'not-active' : ''">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 control-label" for="prepended-input"></label>
                            <div class="col-sm-7">
                                <button (click)="recomputeScore()" [ngClass]="checkInputCert ? '' : 'not-active'" [disabled]="loaderCert" class="btn btn-default pull-left mr10">
                                    <i class="icon-save" [hidden]="true"></i> Recompute</button>
                                <div *ngIf="loaderCert" class="dataInputLoaderSpinner pull-left"></div>
                            </div>
                        </div>
                        <div *ngIf="scores_received">
                            <table class="table">
                                <thead>
                                    <tr>
                                    <th scope="col" class="w70p"></th>
                                    <th scope="col" class="w70p"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Energy score out of 33</td>
                                        <td>{{scores.scores.energy}}</td>
                                    </tr>
                                    <tr>
                                        <td>Energy score out of 100</td>
                                        <td>{{scores.energy}}</td>
                                    </tr>
                                    <tr *ngIf="scores.subscores_carbon">
                                        <td class="pl50">Carbon score out of 100</td>
                                        <td>{{scores.subscores_carbon}}</td>
                                    </tr>
                                    <tr *ngIf="scores.subscores_source">
                                        <td class="pl50">Source score out of 100</td>
                                        <td>{{scores.subscores_source}}</td>
                                    </tr>
                                    <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                                    <tr>
                                        <td>Water score out of 15</td>
                                        <td>{{scores.scores.water}}</td>
                                    </tr>
                                    <tr>
                                        <td>Water score out of 100</td>
                                        <td>{{scores.water}}</td>
                                    </tr>
                                    <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                                    <tr>
                                        <td>Waste score out of 8</td>
                                        <td>{{scores.scores.waste}}</td>
                                    </tr>
                                    <tr>
                                        <td>Waste score out of 100</td>
                                        <td>{{scores.waste}}</td>
                                    </tr>
                                    <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                                    <tr>
                                        <td>Transportation score out of 14</td>
                                        <td>{{scores.scores.transport}}</td>
                                    </tr>
                                    <tr>
                                        <td>Transportation score out of 100</td>
                                        <td>{{scores.transport}}</td>
                                    </tr>
                                    <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                                    <tr>
                                        <td>Human Experience score out of 20</td>
                                        <td>{{scores.scores.human_experience}}</td>
                                    </tr>
                                    <tr>
                                        <td>Human Experience score out of 100</td>
                                        <td>{{scores.human_experience}}</td>
                                    </tr>
                                    <tr *ngIf="scores.leed_subscores_co2">
                                        <td class="pl50">CO2 score out of 100</td>
                                        <td>{{scores.leed_subscores_co2}}</td>
                                    </tr>
                                    <tr *ngIf="scores.leed_subscores_voc">
                                        <td class="pl50">VOC score out of 100</td>
                                        <td>{{scores.leed_subscores_voc}}</td>
                                    </tr>
                                    <tr *ngIf="scores.leed_subscores_occupant">
                                        <td class="pl50">Occupant satisfaction score out of 100</td>
                                        <td>{{scores.leed_subscores_occupant}}</td>
                                    </tr>
                                    <tr *ngIf="scores.subscores_co2">
                                        <td class="pl50">CO2 score out of 100</td>
                                        <td>{{scores.subscores_co2}}</td>
                                    </tr>
                                    <tr *ngIf="scores.subscores_voc">
                                        <td class="pl50">VOC score out of 100</td>
                                        <td>{{scores.subscores_voc}}</td>
                                    </tr>
                                    <tr *ngIf="scores.occupant_satisfaction">
                                        <td class="pl50">Occupant satisfaction score out of 100</td>
                                        <td>{{scores.occupant_satisfaction}}</td>
                                    </tr>
                                    <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                                    <tr>
                                        <td>Base score out of 10</td>
                                        <td>{{scores.scores.base}}</td>
                                    </tr>
                                    <tr>
                                        <td>Base score out of 100</td>
                                        <td>{{(scores.scores.base * 10)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </fieldset>
                </form>
            </section>
        </div>
    </div>
</div>
